module.exports = __webpack_public_path__ + "img/comparative_pain_scale.15c9b93a.png";